import { Box, Avatar, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ReactComponent as LogoSvg } from "../../assets/images/svg/logo/hbscanLogo.svg";
import { useTranslation } from 'react-i18next';
import Topbar from '../../components/topbar/Topbar';

const SuccessScreen = () => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            <Topbar />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    backgroundColor: '#f5f5f5',
                    padding: 4,
                    textAlign: 'center',
                }}
            >
                <Avatar
                    alt="hbscanLogo"
                    variant="square"
                    sx={{
                        background: "none",
                        width: 180,
                        height: 60,
                        marginBottom: 4,
                    }}
                >
                    <LogoSvg />
                </Avatar>

                <Box
                    sx={{
                        backgroundColor: '#ffffff',
                        borderRadius: 8,
                        padding: 6,
                        width: '100%',
                        maxWidth: 500,
                        boxShadow: '0px 12px 32px rgba(0, 0, 0, 0.2)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar
                        sx={{
                            backgroundColor: '#e6f4e6',
                            width: 140,
                            height: 140,
                            marginBottom: 3,
                        }}
                    >
                        <CheckCircleIcon sx={{ color: '#4caf50', fontSize: 100 }} />
                    </Avatar>

                    <Typography variant="h5" sx={{ fontWeight: 700, marginBottom: 2 }}>
                        {t("servicePlus.titleSuccess")}
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#6c757d' }}>
                        {t("servicePlus.messageSuccess")}
                    </Typography>
                </Box>
            </Box>
        </>
    );
};

export default SuccessScreen;
